<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row>
            <v-col cols="12">
               <table-payment-s-f ref="tblpay"></table-payment-s-f>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TablePaymentSF from './Tables/TablePaymentSF.vue'

export default {
   name: "MOMPayments",
   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TablePaymentSF,
   },
   data() {
      return {
         user: Object,
         page: { title: "Membership Payments" },
         breadcrumbs: [
            { text: "Dashboard", disabled: false, to: "/dashboard" },
            { text: "Membership Payments", disabled: true },
         ],
      }
   },
   mounted() {
      this.user = this.$page.user
      if (this.$refs.tblpay && this.user) {
         this.$refs.tblpay.setuserid(this.user.id)
      }
   },
}
</script>
